import {
    DEPARTMENT_ADMIN_FAILED,
    DEPARTMENT_ADMIN_FETCHING,
    DEPARTMENT_ADMIN_SUCCESS,
} from "../../Constants.ts";

export interface DepartmentAdminState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: DepartmentAdminState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): DepartmentAdminState => {
    switch (type) {
        case DEPARTMENT_ADMIN_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case DEPARTMENT_ADMIN_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case DEPARTMENT_ADMIN_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
